import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class ImageButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hover: false
        }
    }

    mouseOver(event) {
        this.setState({
            hover: true
        })
    }

    mouseOut(event) {
        this.setState({
            hover: false
        })
    }

    render() {
        return (
            <img src={this.state.hover ? this.props.pressed : this.props.normal} alt={this.props.alt} onMouseOver={(e) => this.mouseOver(e)} onMouseOut={(e) => this.mouseOut(e)} onClick={this.props.onClick} />
        )
    }
}

ImageButton.propTypes = {
    normal: PropTypes.string,
    pressed: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/ImageButton.js